module.exports = __webpack_public_path__ + "img/0043.983b4731.jpg";